
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getMailSenderOffice365SettingsDtoFormGroup() {
return new FormGroup({
    isConfigured: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    missingSettings: new FormControl<Array<string> | undefined>([], [Validators.required]),
    tenantId: new FormControl<string | undefined>(undefined),
    clientId: new FormControl<string | undefined>(undefined),
    clientSecretConfigured: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    scope: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      